<script lang="ts">
import PanelGroup from '../PanelGroup/PanelGroup.vue';
import PanelGroupCheckbox from '../PanelGroupCheckbox/PanelGroupCheckbox.vue';

type GroupItem = {
  id: string;
  label: string;
  active: boolean;
};

type Group = {
  id: string;
  label: string;
  items: GroupItem[];
};

type Props = {
  groups: Group[];
};
</script>

<script setup lang="ts">
const emit = defineEmits(['change']);
defineProps<Props>();
</script>

<template>
  <div :class="$style.container">
    <PanelGroup v-for="group in groups" :key="group.id" :heading="group.label">
      <PanelGroupCheckbox
        v-for="item in group.items"
        :key="item.id"
        :active="item.active"
        @change="(active) => emit('change', group.id, item.id, active)"
      >
        <span v-html="item.label" />
      </PanelGroupCheckbox>
    </PanelGroup>
  </div>
</template>

<style module lang="scss" src="./MapFilter.scss" />
